import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { ArrowLeft, EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        reset_base_url: window.location.origin,
      });
      setSent(true);
    } catch (e) {
      setErr(formatErr(e?.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-[#F9F7F4]">
      <div className="flex-1 grid place-items-center p-8">
        <div className="w-full max-w-md card !p-10" data-testid="forgot-password-card">
          <Link to="/login" className="text-sm text-[#4F5D4F] hover:text-[#0A3622] inline-flex items-center gap-1" data-testid="back-to-login">
            <ArrowLeft size={14} weight="bold" /> Back to sign in
          </Link>

          {sent ? (
            <div className="mt-5 text-center" data-testid="forgot-sent-card">
              <div className="w-14 h-14 rounded-full bg-[#E2F3EB] grid place-items-center mx-auto">
                <CheckCircle size={28} weight="fill" className="text-[#2D7A5D]" />
              </div>
              <h1 className="font-display text-2xl font-medium tracking-tight text-[#132A13] mt-5">Check your email</h1>
              <p className="text-sm text-[#4F5D4F] mt-3">
                If an account exists for <span className="font-medium text-[#132A13]">{email}</span>, we&apos;ve sent a password-reset link. It expires in 30 minutes.
              </p>
              <p className="text-xs text-[#4F5D4F] mt-6">
                Didn&apos;t get it? Check spam, or{" "}
                <button onClick={() => setSent(false)} className="text-[#F2B632] hover:underline font-medium" data-testid="resend-button">try a different email</button>.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-5" data-testid="forgot-password-form">
              <div className="overline mb-3">Forgot password</div>
              <h1 className="font-display text-3xl font-medium tracking-tight text-[#132A13]">Reset your password</h1>
              <p className="text-sm text-[#4F5D4F] mt-2">Type the email you signed up with. We&apos;ll email you a link to choose a new password.</p>

              <div className="mt-7">
                <label className="text-xs uppercase tracking-[0.14em] text-[#4F5D4F] font-semibold">Email</label>
                <input
                  className="input mt-1"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  data-testid="forgot-email-input"
                />
              </div>
              {err && <p className="text-sm text-[#C93B3B] mt-3" data-testid="forgot-error">{err}</p>}
              <button type="submit" disabled={loading} className="btn-primary w-full justify-center mt-5" data-testid="forgot-submit-button">
                {loading ? "Sending…" : <>Email me a reset link <EnvelopeSimple size={16} weight="fill" /></>}
              </button>

              <p className="text-xs text-[#4F5D4F] mt-6 text-center">
                Remembered it?{" "}
                <Link to="/login" className="text-[#F2B632] hover:underline font-medium">Sign in</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
